import React from 'react';
import { IconButton } from '@fiverr-private/button';
import { translate } from '@fiverr-private/i18n-react';
import { PlusIcon } from '@fiverr-private/visuals';

interface CreateListButtonProps {
    onClick?: React.ComponentProps<typeof IconButton>['onClick'];
}

export const CreateListButton = ({ onClick }: CreateListButtonProps) => (
    <IconButton
        aria-label={translate<string>('collect_actions.add_edit_list_modal.create_title')}
        onClick={onClick}
        intent="secondary"
        variant="ghost"
        shape="circle"
        size="xs"
    >
        <PlusIcon />
    </IconButton>
);
